import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

// Only enroll eligible boys' lines. Preserve quantities and all customer properties.
export async function enrollBoysLines(productIds, root, request = fetch) {
  const read = async (path, options = {}) => {
    const response = await request(`${root}${path}`, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Unable to update boys’ offer');
    return response.json();
  };
  let cart = await read('cart.js');
  let changed = false;
  const limit = cart.items.length + 1;
  for (let i = 0; i < limit; i++) {
    const line = cart.items.find((item) => productIds.has(String(item.product_id)) && item.properties?.__pumper_bundles !== 'mv23omsnfgwtk1');
    if (!line) return { changed, cart };
    cart = await read('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: { ...line.properties, __pumper_bundles: 'mv23omsnfgwtk1' } }),
    });
    changed = true;
  }
  throw new Error('Unable to finish updating boys’ offer');
}

const data = document.getElementById('gf-boys-offer-products');
if (data) {
  const productIds = new Set(JSON.parse(data.textContent).map(String));
  const root = window.Shopify?.routes?.root || '/';
  const ownEvents = new WeakSet();
  let pending = Promise.resolve();
  const sync = () => {
    pending = pending.catch(() => {}).then(async () => {
      const { changed, cart } = await enrollBoysLines(productIds, root);
      if (changed) {
        const event = new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: Promise.resolve({ detail: { cart, itemCount: cart.item_count } }) });
        ownEvents.add(event);
        document.dispatchEvent(event);
      }
    });
    return pending;
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!ownEvents.has(event)) Promise.resolve(event.promise).catch(() => {}).then(sync).catch(console.error);
  });
  sync().catch(console.error);
  window.addEventListener('pageshow', (event) => { if (event.persisted) sync().catch(console.error); });

  // Finish enrolling an older cart before the customer enters standard checkout.
  let resuming = false;
  let checking = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[name="checkout"], a[href*="/checkout"]');
    if (!button || resuming || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await sync();
      resuming = true;
      const currentButton = button.isConnected ? button : document.querySelector('[name="checkout"]');
      if (currentButton) currentButton.click();
      else window.location.assign(button.href || `${root}checkout`);
    } catch (error) {
      console.error(error);
      window.alert('We could not refresh your boys’ bundle savings. Please try checkout again.');
    } finally {
      resuming = false;
      checking = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
}
